export const BusinessTypeCodes = {
	['NB']: 'Native American Owned',
	['1E']: 'Indian Economic Enterprise',
	['1S']: 'Indian Small Business Economic Enterprise',
	['8B']: 'Housing Authorities Public/Tribal',
	['H2']: 'Community Development Corporation',
	['HS']: 'Tribal College',
	['G3']: 'Alaskan Native Servicing Institution',
	['G5']: 'Native Hawaiian Servicing Institution',
	['05']: 'ANC Owned Firm',
	['OW']: 'American Indian Owned',
	['XY']: 'Indian Tribe (Federally Recognized)',
	['8U']: 'Native Hawaiian Owned Firm',
	['1B']: 'Tribally Owned Firm',
}
